// File: frontend/src/pages/StudentAttendanceHistoryPage.jsx

import React, { useState, useEffect, useMemo } from 'react';
import { studentPortalAPI } from '../services/api';
import Spinner from '../components/Spinner';
import toast from 'react-hot-toast';

const STATUS_BADGE = {
    present: 'bg-emerald-100 text-emerald-800',
    late: 'bg-amber-100 text-amber-800',
    absent: 'bg-red-100 text-red-800',
    excused: 'bg-blue-100 text-blue-800',
};

export default function StudentAttendanceHistoryPage() {
    const [records, setRecords] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [classFilter, setClassFilter] = useState('all');

    useEffect(() => {
        studentPortalAPI.getMyAttendanceHistory()
            .then(setRecords)
            .catch(() => toast.error('Could not load attendance history.'))
            .finally(() => setIsLoading(false));
    }, []);

    const classOptions = useMemo(() => {
        return Array.from(new Set(records.map(r => r.class_name)));
    }, [records]);

    const filtered = classFilter === 'all' ? records : records.filter(r => r.class_name === classFilter);

    if (isLoading) return <Spinner />;

    return (
        <div>
            <div className="flex items-center justify-between mb-4 gap-2">
                <h2 className="text-2xl font-bold">My Attendance History</h2>
                {classOptions.length > 1 && (
                    <select
                        value={classFilter}
                        onChange={e => setClassFilter(e.target.value)}
                        className="border rounded-lg p-2 text-sm bg-white dark:bg-gray-800"
                    >
                        <option value="all">All Classes</option>
                        {classOptions.map(name => <option key={name} value={name}>{name}</option>)}
                    </select>
                )}
            </div>
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 divide-y divide-gray-100 dark:divide-gray-700">
                {filtered.length > 0 ? filtered.map((r, i) => (
                    <div key={i} className="p-3.5 flex justify-between items-center">
                        <div>
                            <p className="font-semibold text-sm text-gray-900 dark:text-gray-100">{r.class_name}</p>
                            <p className="text-xs text-gray-500 dark:text-gray-400">{new Date(r.attendance_date).toLocaleDateString()}</p>
                            {r.notes && <p className="text-xs text-gray-400 dark:text-gray-500 italic mt-0.5">{r.notes}</p>}
                        </div>
                        <span className={`text-xs font-bold px-2.5 py-0.5 rounded-full ${STATUS_BADGE[r.status] || 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400'}`}>
                            {r.status}
                        </span>
                    </div>
                )) : <p className="p-6 text-center text-gray-500 dark:text-gray-400">No attendance records found.</p>}
            </div>
        </div>
    );
}
